import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Mail } from './mail';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class MailService {

    private api_url = `${environment.ApiUrl}/mail`;

    constructor(private http: HttpClient) { }

    findAll() {
        return this.http.get<Mail[]>(this.api_url);
    }

    save(mail: Mail) {
        return this.http.post<Mail>(this.api_url, mail, httpOptions);
    }

    update(mail: Mail) {
        return this.http.put<Mail>(this.api_url, mail, httpOptions);
    }

    delete(mail: Mail) {
        const url = `${this.api_url}/${mail.id}`;
        return this.http.delete(url, httpOptions);
    }
}